module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-post-form"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showSavedMessage) ? _c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("Your Post has Successfully been added.")]) : _vm._e()]), _vm._v(" "), (!_vm.isSaving) ? [_c('h3', [_vm._v("Add a Post")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    on: {
      "input": function($event) {
        _vm.errorMessage = ''
      }
    },
    model: {
      value: (_vm.postContent),
      callback: function($$v) {
        _vm.postContent = $$v
      },
      expression: "postContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.submitPost
    }
  }, [_vm._v("Submit")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19770584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsAddPost.vue
// module id = 830
// module chunks = 2